// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2tw0Q","imageUploader":"EGiftCard_imageUploader__Y7C8X"};